module.exports = __webpack_public_path__ + "img/ico_familia.4ef4c92a.svg";